import React, {useContext, useEffect, useState} from "react";
import { Timeline, Space, Checkbox, Button, Form, Alert, Radio, Select, TimePicker, App } from 'antd';
import { DatePicker } from "antd-jalali";
import dayjs, { Dayjs } from 'dayjs'
import moment from 'moment'
import { FaCheck } from "react-icons/fa";
import { Enum, API, ActionType } from "../../resources/constants";
import language from "../../resources/languages/fa_IR";

// Contexts
import GlobalContext from '../../contexts/global';
import AxiosContext from "../../contexts/axios";

const { Components: { Request, Booking: { Policy },  }, Enum: EnumLanguage, Message: MessageLanguage, Validation } = language
const { Message, TravelType } = Enum
const { TRAVEL_TRAVEL_CREATE } = API
const { SET_OPEN_DRAWER } = ActionType

export default function Index() {

    const [form] = Form.useForm()
    const [, forceUpdate] = useState({})
    const { provinces, cars, dispatch } = useContext(GlobalContext)
    const { axios } = useContext(AxiosContext)
    const { message } = App.useApp()
    const [policy, setPolicy] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)

    // To disable submit button at the beginning.
    useEffect(() => {
        forceUpdate({})
        form.resetFields()
    }, []);

    const onFinish = (values: { date: Dayjs, time: Dayjs }) => {
        const { date, time } = values;
        setLoading(true)
        axios.post(TRAVEL_TRAVEL_CREATE, {...values, date: dayjs(moment(date.toDate()).format('YYYY-MM-DD') + ' ' + time.format('HH:mm:ss')), time: undefined}).then((response: {}) => {
            setLoading(false)
            form.resetFields()
            dispatch({ type: SET_OPEN_DRAWER , payload: { openDrawer: false }})
            message.success(MessageLanguage[Message.CREATE_REQUEST]).then(response => response)
        }).catch( (error: {}) => {
            setLoading(false)
            // @ts-ignore
            message.error(MessageLanguage[Message.ERROR_REQUEST]).then(response => response)
        });
    };

    return (
        <Space direction={'vertical'} style={{ width: '100%' }} size={'large'}>
        <Alert message={Request.information} type="info" showIcon={false} />
        <Form form={form} name="request" onFinish={onFinish}>
            <Form.Item
                name="origin"
                dependencies={['destination']}
                rules={[
                    { required: true, message: `${Request.origin} ${Validation.required}` },
                ]}
            >
                <Select
                    showSearch
                    placeholder={Request.origin}
                    optionFilterProp="name"
                    options={provinces.map(({ name, cities }) => ({ label: name, options: cities.map(({ id, name }) => ({ label: name, value: id, name }))}))}
                />
            </Form.Item>
            <Form.Item
                name="destination"
                dependencies={['origin']}
                rules={[
                    { required: true, message: `${Request.destination} ${Validation.required}` },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value || getFieldValue('origin') !== value) return Promise.resolve()
                            else return Promise.reject(new Error(Validation.equalOriginDestination))
                        },
                    }),
                ]}
            >
                <Select
                    showSearch
                    placeholder={Request.destination}
                    optionFilterProp="name"
                    options={provinces.map(({ name, cities }) => ({ label: name, options: cities.map(({ id, name }) => ({ label: name, value: id, name }))}))}
                />
            </Form.Item>
            <Form.Item
                name="date"
                rules={[
                    { required: true, message: `${Request.date} ${Validation.required}` },
                ]}
            >
                <DatePicker allowClear={false}
                            placeholder={Request.date}
                            style={{ width: '100%' }}
                            format="D MMMM"
                            disabledDate={(current: Dayjs) => current && current < dayjs().startOf('day')}
                />
            </Form.Item>
            <Form.Item
                name="time"
                rules={[
                    { required: true, message: `${Request.time} ${Validation.required}` },
                ]}
            >
                <TimePicker allowClear={false}
                            showNow={false}
                            placeholder={Request.time}
                            style={{ width: '100%' }}
                            format="H:m"
                            // disabledTime={(now: Dayjs) => ({
                            //     disabledHours: () => {
                            //         const hours = []
                            //         for (let i = 0; i < Number(dayjs().format('H')); i++)
                            //             hours.push(i)
                            //         return hours
                            //     },
                            //     disabledMinutes: () => {
                            //         const minutes = []
                            //         for (let i = 0; i < Number(dayjs().format('m')); i++)
                            //             minutes.push(i)
                            //         return minutes
                            //     },
                            // })}
                />
            </Form.Item>
            <Form.Item
                name="car"
                rules={[
                    { required: true, message: `${Request.car} ${Validation.required}` },
                ]}
            >
                <Select
                    showSearch
                    placeholder={Request.car}
                    optionFilterProp="label"
                    options={cars.map(({ id, name }) => ({ label: name, value: id }))}
                />
            </Form.Item>
            <Form.Item
                name="travelType"
                className={'request-radio'}
                rules={[
                    { required: true, message: `${Request.travelType} ${Validation.required}` },
                ]}
            >
                <Radio.Group
                    optionType="button"
                    size="large"
                    buttonStyle="solid"
                >
                    <Radio.Button key={0} value={TravelType.Home}>{EnumLanguage.TravelType[TravelType.Home]}</Radio.Button>
                    <Radio.Button key={1} value={TravelType.Close}>{EnumLanguage.TravelType[TravelType.Close]}</Radio.Button>
                </Radio.Group>
            </Form.Item>
            <Form.Item shouldUpdate>
                {() => (
                    <Button
                        type="primary"
                        block
                        htmlType="submit"
                        loading={loading}
                        disabled={
                        !policy ||
                        !!form.getFieldsError().filter(({ errors }) => errors.length).length}
                    >
                        { Request.send }
                    </Button>
                )}
            </Form.Item>
            <Form.Item
                name="policy"
            >
                <Checkbox checked={policy} onChange={({ target: { checked: policy } }) => setPolicy(policy)}><u>{Policy.title}</u></Checkbox>
            </Form.Item>
        </Form>
            {
                policy && (
                    <Timeline
                        className={'policy-timeline'}
                        items={[
                            {
                                dot: <FaCheck />,
                                children: Policy.one,
                            },
                            {
                                dot: <FaCheck />,
                                children: Policy.two,
                            },
                            {
                                dot: <FaCheck />,
                                children: Policy.three,
                            },
                            {
                                dot: <FaCheck />,
                                children: Policy.four,
                            },
                            {
                                dot: <FaCheck />,
                                children: Policy.five,
                            },
                            {
                                dot: <FaCheck />,
                                children: Policy.six,
                            },
                        ]}
                    />
                )
            }
        </Space>
    )
}
